import React, { useState, useEffect } from "react";
import { Typography, Box, ListItemIcon, Divider, Avatar, TextField, InputAdornment, Button, Modal, TableContainer, TableBody, Table, TableHead, TableRow, TableCell, Paper, IconButton, } from "@mui/material";
import axiosInstance from "../../services/axiosInstance";
import axios from "axios";
import { useOutletContext, } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { profileSectionIcon } from "../../pages/MyProfile/profileSectionIcons";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { apiEndpoint } from "../../urls";
import { dashboard } from "../../store/reducers/pdfeditor/dashboardSlice";
import { useLogger } from "../../hooks/useLogger";

const AddCredits = (props) => {
    const {addCreditOpen, setAddCreditOpen, loader, setLoader, paymentsuccess, setPaymentsuccess} = props;
    const logEvent = useLogger();
    const dispatch = useDispatch();
    const { open } = useOutletContext();
    const { profileData } = useSelector((state) => state.profile);
    const { data = {}, status } = useSelector((state) => state.dashboard);
    const [allCraditData, setAllCraditData] = useState({});
    const [showBulkText, setShowBulkText] = useState(false);
    const [aadhaarCredits, setAadhaarCredits] = useState(1);
    const [digitalCredits, setDigitalCredits] = useState(1);
    const [amountWithGST, setAmountWithGST] = useState(118);

    useEffect(() => {
        const totalCredits = (aadhaarCredits * 20) + (digitalCredits * 5);
        const gst = (totalCredits * 18) / 100;
        const total = totalCredits + gst;
        setAmountWithGST(total.toFixed(2));
    }, [aadhaarCredits, digitalCredits]);

    const increaseAadhaarCredits = () => {
        logEvent('Clicked', 'Aadhaar Credit increased', 'New-eSign/addCredit');
        setAadhaarCredits(prev => prev + 1);
    };
    
    const decreaseAadhaarCredits = () => {
        logEvent('Clicked', 'Aadhaar Credit decreased', 'New-eSign/addCredit');
        if (aadhaarCredits > 0) setAadhaarCredits(prev => prev - 1);
    };
    
    const increaseDigitalCredits = () => {
        logEvent('Clicked', 'Digital Credit increased', 'New-eSign/addCredit');
        setDigitalCredits(prev => prev + 1);
    };
    
    const decreaseDigitalCredits = () => {
        logEvent('Clicked', 'Digital Credit decreased', 'New-eSign/addCredit');
        if (digitalCredits > 0) setDigitalCredits(prev => prev - 1);
    };

    useEffect(() => {
        if (data.status) {
            setAllCraditData(data.credits || {});
        }
    }, [data]);

    const handleBackToCredits = async () => {
        try {
            setLoader(true);
            const result = await dispatch(dashboard());
            const updatedCredits = result?.payload?.credits;
            console.log(result);

            if (updatedCredits) {
                setAllCraditData(updatedCredits);
            }
        } catch (error) {
            setLoader(false);
            console.error("Error fetching credits:", error);
        } finally {
            setLoader(false);
            setPaymentsuccess(false);
            setAddCreditOpen(false);
        }
    };

    


    const loadRazorpay = () => {
        if (!document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]')) {
          const script = document.createElement('script');
          script.src = 'https://checkout.razorpay.com/v1/checkout.js';
          script.onload = () => {
            // console.log('Razorpay script loaded.');
          };
          script.onerror = () => {
            console.error('Razorpay script could not be loaded.');
          };
          document.body.appendChild(script);
        }
    };
    
    const generateOrderID = async (amount) => {
        try {
            const response = await axiosInstance.post(`/EsignServices/razorpay/order/${amount}`);    
            return response.data; 
        } catch (error) {
            console.error('Order ID Generation Failed:', error.response?.data || error.message);
            return null;
        }
    };
    
    const handlePayment = async () => {
        logEvent('Clicked', 'Pay button clicked', 'New-eSign/addCredit');

        const orderData = await generateOrderID(amountWithGST * 100);
        // console.log(orderData)
        if (!orderData?.id) {
            alert('Failed to generate Order ID. Please try again.');
            return;
        }
        const options = {
            key: 'rzp_live_fM3BhWsNG9FN5V', // Replace with your Razorpay key ID
            amount: `${amountWithGST * 100}`, // Amount in paisa
            currency: 'INR',
            name: 'Meon Technologies',
            description: 'Transaction For New Esign Recharge',
            image: 'https://meon.co.in/static/meon/img/logo-new.svg',
            order_id: orderData.id,
            handler: function (response) {
                console.log(`Payment Successful! Payment ID: ${response}`, response);
                setLoader(true);
                const creditlog = `${profileData?.company_id} | ${Number(aadhaarCredits?.toString().trim() || 0)} | ${Number(digitalCredits?.toString().trim() || 0)} | ${Number(amountWithGST)} | ${response.razorpay_payment_id}`;
                logEvent('Payment_credit', creditlog, 'Credit');
                checkPayment(response.razorpay_payment_id)
                    .then(response => {
                        console.log(response);
                        if(response?.data?.status===true)
                        {
                            setAddCreditOpen(false);
                            setPaymentsuccess(true);
                            setLoader(false);
                        }
                        else {
                            console.log(response)
                        }
                    })
                    .catch(error => console.error(error));
            },
            prefill: {
                name: '',
                email: '',
                contact: '',
            },
            notes: {
                address: '',
            },
            theme: {
                color: '#007bff',
            },
            modal: {
                ondismiss: function () {
                    // alert('Payment failed or was dismissed!');
                },
            },
        };

        if (window.Razorpay) {
            const razorpay = new window.Razorpay(options);
            razorpay.open();
        } else {
            alert('Razorpay SDK failed to load. Please try again.');
        }
    };

    React.useEffect(() => {
        loadRazorpay();
    }, []);
    
    const checkPayment = async (transactionID) => {
        const url = 'https://invoice.meon.co.in/process_esign_with_invoice';
        
        const headers = {
            'Authorization': 'Bearer ssdjhfmbsjdfhvssfeiorfhjvkbercnjsljcf3roujf',
            'Content-Type': 'application/json'
        };
    
        const payload = {
            company_id: profileData?.company_id,
            credits: Number(aadhaarCredits?.toString().trim() || 0),
            digitalCredits: Number(digitalCredits?.toString().trim() || 0),
            razorpay_payment_id: transactionID,
            expected_amount: Number(amountWithGST)
        };
    
        try {
            const response = await axios.post(url, payload, { headers });
            // console.log('Payment Check Response:', response);
            return response;
        } catch (error) {
            console.error('Payment Check Failed:', error.response?.data || error.message);
            return { error: error.response };
        }
    };


    return (<>
        <Modal open={addCreditOpen} onClose={() => setAddCreditOpen(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "652px",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "hidden",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "27px 30px 25px 30px" }}>
                    <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Add Credits</Typography>
                </Box>
                
                <Box sx={{ height: 35, backgroundColor: "#FFF5E9", display: "flex", alignItems: "center", gap: 1, padding: "0 12px", borderRadius: "8px", justifyContent: "center" }}>
                    <img src={`${process.env.PUBLIC_URL}/images/credit.png`} alt="Credit" style={{ width: 21, height: 21 }} />
                    <Typography sx={{ fontWeight: 400, fontSize: "16px", color: "#5C5C5C" }}>Available Credits - <span style={{ color: "#1D1D1D" }}>Aadhaar:{allCraditData?.aadhaar_credits?.credit_left_integer || 0} / Digital: {allCraditData?.digital_credits?.credit_left_integer || 0} </span> </Typography>
                </Box>

                <Box sx={{ p: "27px 30px 40px 30px", display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", height: 64, background: "#FAFAFA", alignItems: "center", p: "0 30px", borderRadius: "10px 10px 0 0", border: "1px solid #D9D9D9" }}>
                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#222222", width: 295 }}>Signature Type </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#222222", width: 295, textAlign: "right" }}>Number of Credits</Typography>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", height: 64, background: "#ffffff", alignItems: "center", p: "0 30px", border: "1px solid #D9D9D9", borderTop: "none" }}>
                        <Typography sx={{ fontWeight: 400, fontSize: "16px", color: "#555555", width: 295 }}>Aadhaar eSign </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                        <Box sx={{ width: 295, textAlign: "-webkit-right" }}>
                            <Box sx={{ width: 142, height: 30, background: "#EFEFEF", display: "flex", alignItems: "center", padding: "1px", borderRadius: "5px" }}>
                                <IconButton onClick={decreaseAadhaarCredits} size="small" sx={{ background: "#ffffff", borderRadius: "5px 0 0 5px", height: 28, width: 30 }}>
                                    <RemoveIcon />
                                </IconButton>
                                <TextField 
                                    value={aadhaarCredits} 
                                    type="number"
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        "& .MuiOutlinedInput-root": { 
                                            padding: 0,
                                            height: "100%", 
                                            "& fieldset": { border: "none" }
                                        }
                                    }} 
                                    inputProps={{
                                        step: 1,
                                        sx: { textAlign: "center", height: "100%", padding: 0 }, 
                                        // readOnly: true 
                                    }} 
                                    onKeyDown={(e) => {
                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onPaste={(e) => {
                                        const paste = e.clipboardData.getData('text');
                                        if (!/^\d+$/.test(paste)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        const cleanedValue = e.target.value; 
                                        if (cleanedValue === "") {
                                            setAadhaarCredits("");
                                            return;
                                        }
                                        let value = parseInt(cleanedValue);
                                        if (!isNaN(value)) {
                                            if (value >= 0 && value <= 10000) {
                                              setAadhaarCredits(value);
                                              setShowBulkText(value > 999);
                                            }
                                        }
                                        // setAadhaarCredits(Number(value))
                                    }}
                                />
                                <IconButton onClick={increaseAadhaarCredits} size="small" sx={{ background: "#ffffff", borderRadius: "0 5px 5px 0", height: 28, width: 30 }}>
                                    <AddIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "space-between", height: 64, background: "#ffffff", alignItems: "center", p: "0 30px", border: "1px solid #D9D9D9", borderTop: "none" }}>
                        <Typography sx={{ fontWeight: 400, fontSize: "16px", color: "#555555", width: 295 }}>Digital eSign </Typography>
                        <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                        <Box sx={{ width: 295, textAlign: "-webkit-right" }}>
                            <Box sx={{ width: 142, height: 30, background: "#EFEFEF", display: "flex", alignItems: "center", padding: "1px", borderRadius: "5px" }}>
                                <IconButton onClick={decreaseDigitalCredits} size="small" sx={{ background: "#ffffff", borderRadius: "5px 0 0 5px", height: 28, width: 30 }}>
                                    <RemoveIcon />
                                </IconButton>
                                <TextField 
                                    value={digitalCredits}
                                    type="number"
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        "& .MuiOutlinedInput-root": { 
                                            padding: 0,
                                            height: "100%", 
                                            "& fieldset": { border: "none" }
                                        }
                                    }}
                                    inputProps={{ 
                                        step: 1,
                                        sx: { textAlign: "center", height: "100%", padding: 0 }, 
                                        // readOnly: true 
                                    }}
                                    onKeyDown={(e) => {
                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onPaste={(e) => {
                                        const paste = e.clipboardData.getData('text');
                                        if (!/^\d+$/.test(paste)) {
                                          e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => {
                                        const cleanedValue = e.target.value; 
                                        if (cleanedValue === "") {
                                            setDigitalCredits("");
                                            return;
                                        }
                                        let value = parseInt(cleanedValue);
                                        if (!isNaN(value)) {
                                            if (value >= 0 && value <= 10000) {
                                              setDigitalCredits(value);
                                              setShowBulkText(value > 999);
                                            }
                                        }
                                        // setDigitalCredits(Number(value))
                                    }}
                                />
                                <IconButton onClick={increaseDigitalCredits} size="small" sx={{ background: "#ffffff", borderRadius: "0 5px 5px 0", height: 28, width: 30 }}>
                                    <AddIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ minHeight: 64, background: "#FFFFFF", alignItems: "center", borderRadius: "0 0 10px 10px", border: "1px solid #D9D9D9", borderTop: "none", }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: "0 30px", alignItems: "center", }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#555555", width: 295, p: "15px 0 0 0" }}>Aadhaar * 20 </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: "15px 0 0 0" }}>
                                <Typography sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}>
                                    {(aadhaarCredits * 20).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: "0 30px", alignItems: "center", }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#555555", width: 295, p: 0 }}>Digital * 5 </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: 0 }}>
                                <Typography sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}>
                                    {(digitalCredits * 5).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", p: "0 30px", alignItems: "center", }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#555555", width: 295, p: "0 0 15px 0" }}>GST (18%) </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: "0 0 15px 0" }}>
                                <Typography sx={{ fontWeight: 500, fontSize: "18px", color: "#555555" }}>
                                    {((((aadhaarCredits * 20) + (digitalCredits * 5)) * 18) / 100).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#1D1D1D", width: 295, p: "15px 0 15px 30px", background: "#FAFAFA", borderBottomLeftRadius: "10px" }}>Total Payable Amount </Typography>
                            <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#D9D9D9" }} />
                            <Box sx={{ width: 295, textAlign: "right", p: "14px 30px 13px 0", background: "#FAFAFA", borderBottomRightRadius: "10px" }}>
                                <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#1D1D1D" }}>
                                    {amountWithGST}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                {showBulkText && (
                    <Typography sx={{ textAlign: "center", fontWeight: 400, fontSize: "15px", color: "#185cb7", pb: 2, minHeight: "39px"}}>For bulk orders, please contact us at sales@meon.co.in"</Typography>
                )}
                <Divider />
                <Box sx={{ p: "15px 30px 17px 30px", display: "flex", flexDirection: "column", justifyContent: "flex-end", }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "auto", gap: "20px" }}>
                        <Button variant="contained" sx={{ width: '130px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => {setAddCreditOpen(false);}} >
                            Cancel
                        </Button>
                        <Button variant="contained" sx={{ width: '253px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"}, }} onClick={handlePayment} disabled={!aadhaarCredits > 0 && !digitalCredits > 0}  >
                            Proceed to Make Payment
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>

        <Modal open={paymentsuccess}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "652px",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "hidden",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ p: "46px", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                    <Box sx={{ alignSelf: "center", }}>
                        <img src={`${process.env.PUBLIC_URL}/images/creditSuccess.svg`} alt="success" style={{ height: 132 }} />
                    </Box>
                    <Typography variant="p" sx={{ marginTop: "38px", fontSize: "18px", fontWeight: 600, color: "#1D1D1D", textAlign: "center" }}>Your Credit has been Successfully Added!</Typography>
                    <Typography variant="p" sx={{ marginTop: "22px", fontSize: "16px", fontWeight: 400, color: "#5C5C5C", textAlign: "center" }}>You can now use your newly added credits to complete transaction seamlessly.</Typography>
                    
                    <Box sx={{ display: "flex", justifyContent: "center", mt: "38px",}}>
                        <Button variant="contained" sx={{ width: '253px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", }} onClick={ handleBackToCredits }  >
                            Back to Credits
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
        </>
    );
};

export default AddCredits;
